import React from "react";
import PropTypes from "prop-types";
import CityInputComponent, {PROP_NAME_CITY} from "./CityInputComponent";
import {PROP_NAME_IS_POSTAL_CODE_SABRIX, PROP_NAME_POSTAL_CODE} from "./PostalCodeInputComponent";
import {DEFAULT_COUNTRY_CODE, PROP_NAME_COUNTRY} from "./CountryInputComponent";
import StateInputComponent, {PROP_NAME_STATE} from "./StateInputComponent";
import {fetchResponseHandler,extractMessage} from "../../../util/FetchUtil";




class CityStateInputComponent extends React.Component {

    constructor(props){
        super(props);
        this.state = {
            cityOptions: [],
            stateOptions: []
        };
        this.findCityStates = this.findCityStates.bind(this);
        this.findSabrixStatesByCountryCode = this.findSabrixStatesByCountryCode.bind(this);
        this.initFormState = this.initFormState.bind(this);
    }

    componentDidMount() {
        const {data} = this.props;
        const countryCode = data[PROP_NAME_COUNTRY];
        const postalCode = data[PROP_NAME_POSTAL_CODE];

        this.initFormState();

        if (countryCode && countryCode !== DEFAULT_COUNTRY_CODE) {  // hard-coded exclusion of 'US' not ideal
            // currently - only US and CA
            // Canada - has Sabrix states, but not Postal
            this.findSabrixStatesByCountryCode(countryCode);
        }
        if (postalCode) {  // assume isSabrix (on mount, computed value does not exist)
            this.findCityStates(postalCode);
        }
    }

    componentDidUpdate(prevProps) {
        const {data, cityRequired, stateRequired, setFormState} = this.props;
        const countryCode = data[PROP_NAME_COUNTRY];
        const prevCountryCode = prevProps.data[PROP_NAME_COUNTRY];
        const postalCode = data[PROP_NAME_POSTAL_CODE];
        const prevPostalCode = prevProps.data[PROP_NAME_POSTAL_CODE];

        if (countryCode !== prevCountryCode) {
            // clear existing state of Children
            this.setState(state => ({ ...state, cityOptions: [] }));
            this.setState(state => ({ ...state, stateOptions: [] }));
            this.initFormState(true);

            if (countryCode && countryCode !== DEFAULT_COUNTRY_CODE) {
                this.findSabrixStatesByCountryCode(countryCode);
            }
        }

        if (postalCode !== prevPostalCode) {
            if (postalCode && this.props.isPostalCodeSabrix) {
                this.findCityStates(postalCode);  // ie. USA - City-State by Postal
            }
        }
    }

    initFormState(reset = false) {
        const {cityRequired, data, stateRequired, setFormState} = this.props;
        const city = reset ? '' : data[PROP_NAME_CITY];
        const state = reset ? '' : data[PROP_NAME_STATE];
        const hasCity = city && city.trim().length > 0;
        const hasState = state && state.trim().length > 0
        setFormState(
            {property: PROP_NAME_CITY, data: city, metadata: {dirty: hasCity, valid: !cityRequired || hasCity }},
            {property: PROP_NAME_STATE, data: state, metadata: {dirty: hasState, valid: !stateRequired || hasState }}
        );
    }

    /**
     * Find possible City States.
     * If not Sabrix, try Google's Geolocation service.
     */
    findCityStates(postalCode) {
        this.props.userDataService.findCityStatesByPostalCode({postalCode})
            .then(fetchResponseHandler)
            .then((cityStates) => {
                    // decompose into city and state options
                    // example result from backend { city: "UNINCORPORATED", state: {code: "NY", description: "NEW YORK"} }
                if (cityStates && cityStates.length > 0) {
                    const uniqueStateOptions = this.filterUniqueStates(cityStates);
                    const cityOptions = cityStates.map(function (v) {
                        return {id: v.city, text: v.city};
                    });
                    this.setState(state => ({ ...state, cityOptions: cityOptions, stateOptions: uniqueStateOptions  }));
                }
            })
            .catch((e) => {
                const message = extractMessage(e);
                console.log("Error occurs while looking up city-states by postal code: " + message);
            });
    }

    filterUniqueStates(cityStateOptions) {
        const states = cityStateOptions.map(v => v.state);
        let stateMap = new Map();
        let arr = [];
        states.forEach(state => stateMap.set(state.code, state))
        stateMap.forEach(function(value) {
            arr.push(value);
        });
        return arr;
    };

    findSabrixStatesByCountryCode(country) {
        this.props.userDataService.findStatesByCountryCode({country})
            .then(fetchResponseHandler)
            .then((stateOptions) => {
                this.setState(state => ({ ...state, stateOptions: stateOptions }));
            })
            .catch((e) => {
                const message = extractMessage(e);
                console.log("Error occurs while looking up states by country: " + message);
            });
    };




    render(){
        const {data, metadata, readOnly, setFormState, userDataInit} = this.props;
        const {cityRequired = true, stateRequired = true} = this.props;
        const {cityOptions, stateOptions} = this.state;

        return (
            <div>
                <ul className="form-fields grid">
                    <CityInputComponent
                        data={data}
                        metadata={metadata}
                        options={cityOptions}
                        readOnly={readOnly}
                        required={cityRequired}
                        setFormState={setFormState}
                        userDataInit={userDataInit}
                    />
                    <StateInputComponent
                        data={data}
                        metadata={metadata}
                        options={stateOptions}
                        readOnly={readOnly}
                        required={stateRequired}
                        setFormState={setFormState}
                        userDataInit={userDataInit}
                    />
                </ul>
            </div>
        );
    }
}


CityStateInputComponent.propTypes = {
    cityRequired: PropTypes.object.isRequired,
    data: PropTypes.object.isRequired,
    isPostalCodeSabrix: PropTypes.object.isRequired,
    metadata: PropTypes.object.isRequired,
    readOnly: PropTypes.object,
    setFormState: PropTypes.func.isRequired,
    stateRequired: PropTypes.object.isRequired,
    userDataInit: PropTypes.object.isRequired,
    userDataService: PropTypes.object.isRequired
};

export default CityStateInputComponent;